import { makeStyles } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import LanguageContext from '../../../contexts/languageContext';
import MessagesContext from '../../../contexts/messagesContext';
import { MainDialog, SubmitButton } from '../../UI';
import { PlusIcon } from '../../UI/Icons';
import AddOrEditUser from './AddOrEditUser';

const styles = makeStyles({
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '40px'
    },
    sticky: {
        position: 'sticky',
        right: '0'
    },
    title: ({ rtl }) => ({
        fontSize: '15px',
        fontWeight: 'bold',
        position: 'sticky',
        right: rtl ? '0' : 'unset',
        left: !rtl ? '0' : 'unset'
    }),
    buttonWrapper: ({ rtl }) => ({
        width: '140px',
        position: 'fixed',
        top: '75px',
        left: rtl ? '75px' : 'unset',
        right: !rtl ? '75px' : 'unset',
        '& button': {
            display: 'flex',
            alignItems: 'center'
        },
        '& svg': {
            marginInlineEnd: '8px'
        }
    })
});
const ManageUsersHeader = () => {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const { messages } = useContext(MessagesContext);
    const [dialog, setDialog] = useState(false);
    const handleAddUser = () => {
        setDialog(true);
    };
    return (
        <>
            <div className={classes.row}>
                <span className={classes.title}>{messages.permissionsTitle.manage_user}</span>
                <div className={classes.buttonWrapper}>
                    <SubmitButton
                        isButton
                        handleClick={handleAddUser}
                        mr={'0'}
                        fullWidth
                        data-testid="newUser"
                    >
                        <PlusIcon width="17px" height="17px" />
                        <span>{messages.newUser}</span>
                    </SubmitButton>
                </div>
            </div>
            <MainDialog open={dialog} goBack={() => setDialog(false)}>
                <AddOrEditUser setDialog={() => setDialog(false)} />
            </MainDialog>
        </>
    );
};

export default ManageUsersHeader;
